import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/ServiceCategories";
import getToken from "app/api/getToken";

import { IServiceCategory } from "app/api/types";

export const EDIT_SERVICE_CATEGORY_REQUEST = "EDIT_SERVICE_CATEGORY_REQUEST";
export const EDIT_SERVICE_CATEGORY_SUCCESS = "EDIT_SERVICE_CATEGORY_SUCCESS";
export const EDIT_SERVICE_CATEGORY_FAIL = "EDIT_SERVICE_CATEGORY_FAIL";

export const editServiceCategory = (data: IServiceCategory) => (
  dispatch: any
): any => {
  dispatch({ type: EDIT_SERVICE_CATEGORY_REQUEST });

  const token = getToken();

  return api
    .editServiceCategory(token, data)
    .then((response: AxiosResponse) => {
      const serviceCategory: IServiceCategory = get(response, "data", {});
      dispatch({
        type: EDIT_SERVICE_CATEGORY_SUCCESS,
        payload: serviceCategory
      });

      return serviceCategory;
    })
    .catch(err => {
      dispatch({
        type: EDIT_SERVICE_CATEGORY_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
